module.exports = __webpack_public_path__ + "img/1.dd1876c9.png";